import React from 'react';
import { styled } from "styled-components";
import { t } from 'ttag';

const Wrapper = styled.div`
  a {
    position: relative;
    margin-left: auto;
    display: block;
    border: 0px;
    height: 38px;
    padding: 6px 20px;
    border-radius: 8px;
    background: #9738FF;
    color: #FFF;
    text-align: center;
    font-variant-numeric: lining-nums proportional-nums;
    font-family: Raleway;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    text-decoration: auto;
    
    margin-top: 20px;
  }
`;

const PageNotExist = () => {
  return (
    <Wrapper>
      <h2>EasyLlama</h2>
      <div className='row'>
        <p>
          {t`Oh no, drama-llama!`}<br />
          {t`The page you are looking for does not exist.`}
        </p>
        <p>{t`You may want to head back to the homepage.`}</p>
        <a className="border-button" href="https://www.easyllama.com">{t`Go to homepage`}</a>
      </div>
    </Wrapper>
  );
};

export default PageNotExist;
